import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Tabs as MantineTabs } from '@mantine/core';
import { SquareLoader } from '@hud/web-components/Loader/SquareLoader';
import { xsLight } from '@hud/web-components/theme/typography';
import { themeColor } from '@hud/web-components/theme/colors';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';
import useAnalytics from '../../../../hooks/useAnalytics';
import { StepStyles as Styled } from '../SetupSteps.styles';
import { Tabs, Footer } from './InstallSDK.styles';
import NodeTab from './NodeTab';
import PythonTab from './PythonTab';
import JavaTab from './JavaTab';
import DotnetTab from './DotnetTab';
import { ContactUsLink } from '../../../../components/ContactUsLink/ContactUsLink';

import InstallSDKPopover from './InstallSDKPopover';

export function InstallSDKStep() {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.capture('sdk_install_page_viewed');
  }, [analytics]);

  return (
    <Styled.Container>
      <Styled.Subtitle>Step 2</Styled.Subtitle>
      <Styled.Title>
        Install Hud SDK
        <InstallSDKPopover>
          <HudIcon icon={'other.circleHelp'} size="24px" />
        </InstallSDKPopover>
      </Styled.Title>

      <Tabs defaultValue="nodejs">
        <MantineTabs.List>
          <MantineTabs.Tab value="nodejs">
            <Styled.IconContainer>
              <HudIcon icon="languages.nodejs" size={'16px'} /> Node
            </Styled.IconContainer>
          </MantineTabs.Tab>
          <MantineTabs.Tab value="python">
            <Styled.IconContainer>
              <HudIcon icon="languages.python" size={'16px'} /> Python
            </Styled.IconContainer>
          </MantineTabs.Tab>
          <MantineTabs.Tab value="java">
            <Styled.IconContainer>
              <HudIcon icon="languages.java" size={'18px'} /> Java
            </Styled.IconContainer>
          </MantineTabs.Tab>
          <MantineTabs.Tab value="dotnet">
            <Styled.IconContainer>
              <HudIcon icon="languages.dotnet" size={'18px'} /> .NET
            </Styled.IconContainer>
          </MantineTabs.Tab>
        </MantineTabs.List>
        <NodeTab />
        <PythonTab />
        <JavaTab />
        <DotnetTab />
      </Tabs>

      <LoadingFooter>
        <Loader>
          <SquareLoader size={16} />
          <div className="mesage">
            Once data arrives you’ll be redirected to the Hud app
          </div>
        </Loader>
      </LoadingFooter>

      <Footer>
        <FooterHelp>
          Need help?{' '}
          <ContactUsLink startConversationContent="Hi, I need help installing the SDK.">
            Chat with our support team
          </ContactUsLink>{' '}
          or email us at <a href="mailto:support@hud.io">support@hud.io</a>.
        </FooterHelp>
      </Footer>
    </Styled.Container>
  );
}

const LoadingFooter = styled.div`
  margin: 16px 0;
`;

const FooterHelp = styled.div`
  flex: 1;
  ${xsLight};
  color: ${themeColor('textSecondary')};

  a {
    color: ${themeColor('turquoise')};
    text-decoration: none;
    &:hover {
      color: ${themeColor('turquoise')};
      text-decoration: underline;
    }
  }
`;

const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
